"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaQueryProvider = exports.MediaQueryContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const media_constants_1 = require("./media-constants");
/**
 * MediaQueryContext that signifies the width of the DOM at any given point.
 */
exports.MediaQueryContext = (0, react_1.createContext)(undefined);
function useWindowWidth() {
    // Default value is a mobile width
    const [windowWidth, setWindowWidth] = (0, react_1.useState)(media_constants_1.MOBILE_MAX_WIDTH);
    (0, react_1.useEffect)(() => {
        function resizeHandler() {
            setWindowWidth(window.innerWidth);
        }
        // calling resize handler right away for initial value
        resizeHandler();
        window.addEventListener("resize", resizeHandler);
        return () => {
            window.removeEventListener("resize", resizeHandler);
        };
    }, []);
    return windowWidth;
}
/**
 * MediaQueryProvider that should be applied at the top of a page.
 * This Provider makes sure we have a listener which can measure the width of the page.
 */
function MediaQueryProvider({ widthOverride, children, }) {
    const windowWidth = useWindowWidth();
    const contextVal = (0, react_1.useMemo)(() => ({ width: widthOverride || windowWidth }), [widthOverride, windowWidth]);
    return (0, jsx_runtime_1.jsx)(exports.MediaQueryContext.Provider, { value: contextVal, children: children });
}
exports.MediaQueryProvider = MediaQueryProvider;
//# sourceMappingURL=MediaQueryContext.js.map